import { useSession } from "../../hooks/useSession";
import { useAppointmentResponse } from "../../hooks/useAppointmentResponse";
import { useDynatrace } from "../../hooks/useDynatrace";

export const useClinkRicontattoPage = () => {
  const { read, update } = useSession();
  const { handleAppointmentSubmission, isCreaAppuntamentoBusy, isCreaAppuntamentoError, fetchErrorMessage, fetchError, setFetchError } = useAppointmentResponse();

  const next = () => {
    handleAppointmentSubmission();
  };

  const {} = useDynatrace();

  const onNomeChange = (value) => {
    update("nome", value);
  };
  const onCognomeChange = (value) => {
    update("cognome", value);
  };
  const onEmailChange = (value) => {
    update("email", value);
  };
  const onCellulareChange = (value) => {
    update("cellulare", value);
  };

  return {
    next,
    read,
    update,
    onNomeChange,
    onCognomeChange,
    onEmailChange,
    onCellulareChange,
    isCreaAppuntamentoBusy,
    isCreaAppuntamentoError,
    fetchErrorMessage,
    fetchError,
    setFetchError,
  };
};
